import axios from "axios";
import { RequestMode } from "@/types/common";
import { ResponseApplicationType, ResponseDataList, ResponseRequestType } from "@/types/service";
import { ApiConstant } from "@/const";
import { HumpsUtils } from "@/utils";
import GlobalApi, { ApiResponse } from "./config/api.config";
import { Console } from "console";

export type RequestPayloadType = {
  applicationSendUid?: string;
  startDate?: number;
  endDate?: number;
  requestId?: string;
  status?: number;
  page: number;
  size: number;
  internalF: boolean;
};

export type ResponsePayloadType = {
  applicationSendUid?: string;
  startDate?: number;
  endDate?: number;
  filter?: string;
  status?: number;
  page: number;
  size: number;
  typeResponse: number;
  requestStatus?: number;
};

export const formatResponseData = (response: any) => {
  return {
    ...response,
    data: response?.data?.map((item: ResponseRequestType) => {
      return {
        ...item,
        uid: item?.requestId,
        applicationSendUid: item?.applicationSend?.uid,
        applicationSendName: item?.applicationSend?.name,
        createdAt: item?.created && new Date(item?.created),
        responseAt:
          (item?.transferResponseData?.created && new Date(item?.transferResponseData?.created)) ??
          (item?.modified && new Date(item?.modified)), // TODO: Fix
      };
    }),
  };
};

export const getRequest = async (payload: RequestPayloadType) => {
  const response = await GlobalApi.toCamel().get<ResponseDataList<ResponseRequestType>>(
    ApiConstant.GET_INTERNAL_LIST,
    HumpsUtils.decamelizeKeys(payload),
  );
  if (response.ok && response.data) return formatResponseData(response.data);
  throw response;
};

export const exportRequest = async (requestUidList: string[], mode: RequestMode) => {
  const payload = HumpsUtils.decamelizeKeys<Record<string, string>>({
    requestUids: requestUidList.join(","),
  });
  const path = mode === "internal" ? ApiConstant.GET_QUEUE_EXPORT_REQUEST : ApiConstant.GET_QUEUE_EXPORT_RESPONSE;
  const response = await GlobalApi.default().get<ArrayBuffer>(path, payload, { responseType: "arraybuffer" });
  if (response.status === ApiConstant.HTTP_STATUS.STT_OK && response.data) return response.data;
  throw response;
};

export const updateRequestStatus = async (requestUidList: string[], status: number) => {
  const payload = HumpsUtils.decamelizeKeys<Record<string, string>>({
    status: status.toString(),
    transferRequestUids: requestUidList.join(","),
  });
  const urlSearchParams = new URLSearchParams(payload);
  const response = await GlobalApi.toCamel().put(
    `${ApiConstant.PUT_UPDATE_REQUEST_STATUS}?${urlSearchParams.toString()}`,
  );
  if (response.ok) return response;
  throw response;
};

export const getAllApplicationList = async () => {
  const response = await GlobalApi.toCamel().get<ResponseDataList<ResponseApplicationType>>(
    ApiConstant.GET_APPLICATIONS,
    HumpsUtils.decamelizeKeys({ internalF: true }),
  );
  if (response.ok && response.data) return response.data;
  throw response;
};

export const importRequest = async (formData: FormData) => {
  const mode = formData.get("mode");
  const response = await GlobalApi.toCamel().post<ApiResponse<any>>(
    mode === "internal" ? ApiConstant.POST_QUEUE_IMPORT_RESPONSE : ApiConstant.POST_QUEUE_IMPORT_REQUEST,
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
      timeout: 300000,
    },
  );
  if (response.ok && response.data) return response.data;
  throw response;
};

export const getResponse = async (payload: ResponsePayloadType) => {
  const response = await GlobalApi.toCamel().get<ResponseDataList<ResponseRequestType>>(
    ApiConstant.GET_EXTERNAL_LIST,
    HumpsUtils.decamelizeKeys(payload),
  );
  if (response.ok && response.data) return formatResponseData(response.data);
  throw response;
};
